export const anticipationRule = state => state.anticipationRule;
export const anticipationTax = state => state.anticipationTax;
export const anticipationsAvailable = state => state.anticipationsAvailable;
export const anticipationsAvailableCount = state => state.anticipationsAvailableCount;
export const balance = state => state.balance;
export const currentTax = state => state.currentTax;
export const selectedAnticipations = state => state.selectedAnticipations;
export const selectedAnticipationsAmount = state => state.selectedAnticipationsAmount;
export const anticipationsAvailablePage = state => state.anticipationsAvailablePage;
export const anticipationsAvailableLimit = state => state.anticipationsAvailableLimit;
export const loading = state => state.loading;
export const automaticAnticipationEnabled = state => state.automaticAnticipationEnabled;
export const anticipationRequestPending = state => state.anticipationRequestPending;

export const anticipationsFilter = (state) => {
  const filters = {
    page: state.anticipationsAvailablePage,
    limit: state.anticipationsAvailableLimit,
  };
  return filters;
};
